import { orderHistory } from './order-history-en.i18n';

export const en = {
  orderHistory,
};
